import { css, type Theme } from '@emotion/react';

import { COLLAPSED_SIDEBAR_WIDTH, EXPANDED_SIDEBAR_WIDTH } from './constants';

export const sidebarContainer = (theme: Theme) => css`
  // Has to be absolute to go over content on phone
  position: absolute;
  top: 0;
  left: -${COLLAPSED_SIDEBAR_WIDTH}px;
  width: ${COLLAPSED_SIDEBAR_WIDTH}px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 8px;

  height: 100%;
  overflow-y: auto;

  background-color: ${theme.colors.gray[0]};
  border-right: 1px solid ${theme.colors.gray[100]};

  z-index: 5;

  transition: ${theme.transitions.default('width')};

  &:not(.isOpen) {
    padding: 10px 0px;
    }

  &.isOpen {
    left: 0;
    width: ${EXPANDED_SIDEBAR_WIDTH}px;
  }

  @media (min-width: ${theme.breakpoints.small}) {
    &:not(.isOpen) {
      left: 0;
    }
  }
`;
